var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 49,
    viewBox: "0 0 39 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.375 17.375V12.625C31.375 5.975 26.15 0.75 19.5 0.75C12.85 0.75 7.625 5.975 7.625 12.625V17.375C3.5875 17.375 0.5 20.4625 0.5 24.5V41.125C0.5 45.1625 3.5875 48.25 7.625 48.25H31.375C35.4125 48.25 38.5 45.1625 38.5 41.125V24.5C38.5 20.4625 35.4125 17.375 31.375 17.375ZM12.375 12.625C12.375 8.5875 15.4625 5.5 19.5 5.5C23.5375 5.5 26.625 8.5875 26.625 12.625V17.375H12.375V12.625ZM22.1125 32.8125L21.875 33.05V36.375C21.875 37.8 20.925 38.75 19.5 38.75C18.075 38.75 17.125 37.8 17.125 36.375V33.05C15.7 31.625 15.4625 29.4875 16.8875 28.0625C18.3125 26.6375 20.45 26.4 21.875 27.825C23.3 29.0125 23.5375 31.3875 22.1125 32.8125Z",
    fill: "#FF0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.54af2836.svg";
export { ForwardRef as ReactComponent };